import { useState, useCallback } from "react";

export function useHODMutation(fn, options = {}) {
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const mutate = useCallback(
        async (variables) => {
            setIsLoading(true);
            setIsSuccess(false);
            setIsError(false);
            setError(null);
            try {
                const result = await fn(variables);
                setData(result);
                setIsLoading(false);
                setIsSuccess(true);
                options.onSuccess?.(result, variables);
                return result;
            } catch (err) {
                setIsLoading(false);
                setIsSuccess(false);
                setIsError(true);
                setError(err);
                options.onError?.(err, variables);
                // throw err; // optional
            }
        },
        [fn, options]
    );

    const reset = useCallback(() => {
        setIsLoading(false);
        setIsSuccess(false);
        setIsError(false);
        setError(null);
        setData(null);
    }, []);

    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data,
        reset,
    };
}
